// extracted by mini-css-extract-plugin
export default {"container":"kgLdFfZ2hQfjfo01QA4R","bankAccount":"pSmkLuquogd1JUGeRPa9","descriptionLabel":"CSksdp8UnKl6KxCdjzRy","descriptionLabelMobile":"EfhroxJ30ZWZka4b8bEj"};